import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import api from '@/api';
import '@/bootstrap';

Vue.config.productionTip = false;

const loadApp = () =>
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app');

// Auth
if (api.isTokenValid()) {
  api
    .user({ include: 'platform,role.permissions' })
    .then(({ data }) => {
      store.commit('setUser', data);
    })
    .finally(() => {
      loadApp();
    });
} else {
  loadApp();
}
